// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width:769px){.side .spiral canvas[data-v-7395623b]{max-width:100%}}", "",{"version":3,"sources":["webpack://./resources/js/views/FoodInsights.vue"],"names":[],"mappings":"AACA,yBACE,sCACE,cAAF,CACF","sourcesContent":["\n@media (max-width: 769px) {\n  .side .spiral canvas {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
